import StarOutline from "./StarOutline";

export default StarOutline;
